import { JSX, ReactNode } from "react";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import "./Styles.scss";

export type GridSpacing =
    | 'none'
    | '2xs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl'
    | '2xl' | '3xl' | '4xl' | '5xl' | '6xl'
    | 'form' | 'cards';

export class GridContainer extends BaseComponent<IGridContainerProps, IGridContainerState>
{
    private gridSpacingVar: Record<GridSpacing, string> = {
        'none': 'var(--spacing-sd-system-dimension-spacing-none)',
        '2xs': 'var(--spacing-sd-system-dimension-spacing-two-extra-small)',
        'xs': 'var(--spacing-sd-system-dimension-spacing-extra-small)',
        'sm': 'var(--spacing-sd-system-dimension-spacing-small)',
        'md': 'var(--spacing-sd-system-dimension-spacing-medium)',
        'lg': 'var(--spacing-sd-system-dimension-spacing-large)',
        'xl': 'var(--spacing-sd-system-dimension-spacing-extra-large)',
        '2xl': 'var(--spacing-sd-system-dimension-spacing-two-extra-large)',
        '3xl': 'var(--spacing-sd-system-dimension-spacing-three-extra-large)',
        '4xl': 'var(--spacing-sd-system-dimension-spacing-four-extra-large)',
        '5xl': 'var(--spacing-sd-system-dimension-spacing-five-extra-large)',
        '6xl': 'var(--spacing-sd-system-dimension-spacing-six-extra-large)',
        'form': 'var(--spacing-sd-system-dimension-spacing-small)',
        'cards': 'var(--spacing-sd-system-dimension-spacing-three-extra-large)',
    }

    public render(): JSX.Element
    {
        const {
            children,
            className = '',
            style = {},
            spacing = 'form',
        } = this.props;

        const cssClasses: string[] = [];
        cssClasses.push('grid');
        cssClasses.push('grid__container');
        cssClasses.push(className);

        const mergedStyle = {
            '--grid-spacing': this.gridSpacingVar[spacing],
            ...style,
        } as React.CSSProperties;

        return (
            <div
                {...this.props}
                className={cssClasses.filter(i => !!i).join(' ')}
                style={mergedStyle}
            >
                {children}
            </div>
        );
    }
}

export interface IGridContainerProps extends React.HTMLAttributes<HTMLDivElement>
{
    spacing?: GridSpacing;
}

export interface IGridContainerState { }
